import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';

@Component({
  selector: 'app-departmentSheet-table',
  templateUrl: './departmentSheet-table.component.html',
  styleUrls: ['./departmentSheet-table.component.css'],
})

export class DepartmentSheetTable implements OnInit {
  constructor(
    private ngProgress: NgProgress,
      private store: Store<any>,
      private modal: NgbModal,
  ){}

  @Input()
  departmentSheetInfo: any;

  progressRef: NgProgressRef;
  _modalRef: any;

  get dataDepartmentSheet(){
    return (this.departmentSheetInfo && Object.keys(this.departmentSheetInfo)) || []
  }

  ngOnInit() {
    this.progressRef = this.ngProgress.ref();
  }
}